import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Dashboard from './Dashboard';
import { decodeColumnsFromUrl } from '../../utils/DashboardColumnsUrlParams';
import { useUiVersion } from '../../context/UserModulesContext';

export const DashboardWrapper = () => {
    const location = useLocation();
    const navigate = useNavigate();
    // El Tablero es UNA pantalla compartida por el clásico y la 2.1: la tuerca por columna es
    // lo único que las distingue, así que el flag baja por prop (Dashboard es de clase).
    const { isV2, loaded: uiVersionLoaded } = useUiVersion();

    // Create a history-like object for backwards compatibility
    const history = {
        push: navigate,
        replace: (path) => navigate(path, { replace: true }),
        // Add other history methods as needed
    };

    const sharedColumns = decodeColumnsFromUrl();

    return <Dashboard location={location} history={history} sharedColumns={sharedColumns}
                      showsColumnSensitivity={uiVersionLoaded && isV2} />;
}; 